
import AdminSetupTool from '@/components/AdminSetupTool';
import { useRoleGuard } from '@/hooks/use-role-guard';

export default function AdminSetupPage() {
  // Protect this page with role guard - only admins should access
  const { isLoading } = useRoleGuard(['admin']);
  
  if (isLoading) {
    return <div className="flex justify-center items-center min-h-screen">Loading...</div>;
  }
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Admin Setup Tool</h1>
      <AdminSetupTool />
    </div>
  );
}
